<div class="full layout-col">
  <elder-table
    class="full"
    [data]="data"
    [selectionVisible]="true"
    [selectionMultiEnabled]="true"
    (itemClick)="open($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      [canAdd]="true"
      [canRemove]="true"
      [canMore]="true"
      (requestNew)="onCreate()"
      (requestRemove)="onRemove($event)"
    >
      <button mat-menu-item [disabled]="!data.isEmpty" (click)="createGlobal()">
        <mat-icon>public</mat-icon>
        <span>{{ 'jssp.global' | translate }}</span>
      </button>
    </elder-data-toolbar>

    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
      <td mat-cell *matCellDef>
        <mat-icon>business</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef>{{ 'context.facility' | translate }}</th>
      <td mat-cell *matCellDef="let record">
        {{ record?.facility }}
      </td>
    </ng-container>

    <ng-container matColumnDef="maxPackageWeight">
      <th mat-header-cell *matHeaderCellDef>{{ 'jssp.maxPackageWeight' | translate }}</th>
      <td mat-cell *matCellDef="let record">
        {{ record?.maxPackageWeightKg }}
      </td>
    </ng-container>

    <ng-container matColumnDef="productionMinuteCost">
      <th mat-header-cell *matHeaderCellDef>{{ 'jssp.productionMinuteCost' | translate }}</th>
      <td mat-cell *matCellDef="let record">
        {{ record?.productionMinuteCost }}
      </td>
    </ng-container>

    <ng-container matColumnDef="involvedWcCost">
      <th mat-header-cell *matHeaderCellDef>{{ 'jssp.involvedWcCost' | translate }}</th>
      <td mat-cell *matCellDef="let record">
        {{ record?.involvedWcCost }}
      </td>
    </ng-container>

    <ng-container matColumnDef="involvedPackageCost">
      <th mat-header-cell *matHeaderCellDef>{{ 'jssp.involvedPackageCost' | translate }}</th>
      <td mat-cell *matCellDef="let record">
        {{ record?.involvedPackageCost }}
      </td>
    </ng-container>

    <ng-container matColumnDef="unequalDistributionCost">
      <th mat-header-cell *matHeaderCellDef>{{ 'jssp.unequalDistributionCost' | translate }}</th>
      <td mat-cell *matCellDef="let record">
        {{ record?.unequalDistributionCost }}
      </td>
    </ng-container>
  </elder-table>
</div>
